import { createRouter, createWebHashHistory } from 'vue-router';
import Layout from '../layouts/BaseLayout.vue';
import HomeView from '../views/home/index.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Layout,
    redirect: '/home',
    children: [
      // 首页
      {
        path: '/home',
        name: 'Home',
        component: HomeView,
      },
      // 待定
      {
        path: '/about',
        name: 'About',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/about/index.vue'),
      },
      // 国内物流
      {
        path: '/domesticLogistics',
        name: 'DomesticLogistics',
        redirect: '/domesticLogistics/home',
        component: () => import('../views/DomesticLogistics/layout.vue'),
        children: [
          // 国内物流主页面
          {
            path: 'home',
            name: 'DomesticLogisticshome',
            component: () =>
              import(
                /* webpackChunkName: "about" */ '../views/DomesticLogistics/index.vue'
              ),
          },
          // 国内物流子页面-详情/下单
          {
            path: 'logisticParticulars',
            name: 'LogisticParticulars',
            component: () =>
              import(
                /* webpackChunkName: "about" */ '../views/DomesticLogistics/logisticParticulars.vue'
              ),
          },
          {
            path: 'logisticOrder',
            name: 'LogisticOrder',
            component: () =>
              import(
                /* webpackChunkName: "about" */ '../views/DomesticLogistics/logisticOrder.vue'
              ),
          },
        ],
      },
      // 国际物流
      {
        path: '/internationalLogistics',
        name: 'InternationalLogistics',
        redirect: '/internationalLogistics/home',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/InternationalLogistics/layout.vue'
          ),
          children: [
            {
              path: 'home',
              name: 'InternationalLogisticshome',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/index.vue'
                ),
            },
            {
              path: 'seawaydata',
              name: 'Seawaydata',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/seawaydata.vue'
                ),
            },
            {
              path: 'seawayOrder',
              name: 'SeawayOrder',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/seawayOrder.vue'
                ),
            },
            {
              path: 'airwaydata',
              name: 'Airwaydata',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/airwaydata.vue'
                ),
            },
            {
              path: 'airwayOrder',
              name: 'AirwayOrder',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/airwayOrder.vue'
                ),
            },
            {
              path: 'landwaydata',
              name: 'Landwaydata',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/landwaydata.vue'
                ),
            },
            {
              path: 'landwayOrder',
              name: 'LandwayOrder',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/InternationalLogistics/landwayOrder.vue'
                ),
            },
          ]
      },

      // 货源信息
      {
        path: '/freightSource',
        name: 'FreightSource',
        redirect: '/freightSource/home',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/freightSource/layout.vue'
          ),
          children: [
            {
              path: 'home',
              name: 'FreightSourcehome',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/freightSource/index.vue'
                ),
            },
            {
              path: 'takeOrder',
              name: 'TakeOrder',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/freightSource/takeOrder.vue'
                ),
            },
            {
              path: 'freightQuotation',
              name: 'FreightQuotation',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/freightSource/freightQuotation.vue'
                ),
            },
          ]
      },
      // 车源信息
      {
        path: '/vehicleSource',
        name: 'VehicleSource',
        redirect: '/vehicleSource/home',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/vehicleSource/layout.vue'
          ),
          children: [
            {
              path: 'home',
              name: 'VehicleSourcehome',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/vehicleSource/index.vue'
                ),
            },
            {
              path: 'vehicledata',
              name: 'Vehicledata',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/vehicleSource/vehicledata.vue'
                ),
            },
            {
              path: 'vehicleOrder',
              name: 'VehicleOrder',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/vehicleSource/vehicleOrder.vue'
                ),
            },
          ]
      },
      // 物流园区
      {
        path: '/logisticsPark',
        name: 'LogisticsPark',
        redirect: '/logisticsPark/home',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/logisticsPark/layout.vue'
          ),
          children: [
            {
              path: 'home',
              name: 'LogisticsParkhome',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/logisticsPark/index.vue'
                ),
            },
            {
              path: 'parkData',
              name: 'ParkData',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/logisticsPark/parkData.vue'
                ),
            },
          ]
      },
      // 物流资讯
      {
        path: '/logisticsInformation',
        name: 'LogisticsInformation',
        redirect: '/logisticsInformation/home',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/logisticsInformation/layout.vue'
          ),
          children: [
            {
              path: 'home',
              name: 'LogisticsInformationhome',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/logisticsInformation/index.vue'
                ),
            },
            {
              path: 'logisticsInformation-data',
              name: 'LogisticsInformation-data',
              component: () =>
                import(
                  /* webpackChunkName: "about" */ '../views/logisticsInformation/indexData.vue'
                ),
            },
          ]
      },
      // 平台简介
      {
        path: '/platformIntroduction',
        name: 'PlatformIntroduction',
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/platformIntroduction/index.vue'
          ),
      },
      // 首页运价查询
      {
        path: '/freightRateView/index',
        name: 'freightRateView',
        component: () => import('../views/freightRateView/index.vue')
      },
      // 物流单号追踪
      {
        path: '/trackView/index',
        name: 'TrackView',
        component: () => import('../views/trackView/index.vue')
      },
      {
        path: '/factoryView/index',
        name: 'FactoryView',
        component: () => import('../views/factoryView/index.vue')
      }
    ],
  },
  {
    path: "/identity",
    name: "Identity",
    component: () => import('@/views/identity/index.vue'),
    meta: {
      title: "选择身份"
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0, behavior: 'smooth' };
  },
});

export default router;
